import React, { Component } from 'react';
import 'index.css';
import 'components/Geoloc.scss';
import FormHelperText from '@material-ui/core/FormHelperText';
import axios from 'axios';
import Qs from 'qs';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';

import Conf from 'utils/Conf';
import Pager from 'components/Pager';
import { Trans, withTranslation } from 'react-i18next';

class PasswordReset extends Component {
    constructor(props){
        super(props);
        this.state={
            password:'',
            passwordConfirm:'',
            errors:{},
            error:'',
            idx:0,
        }
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.setError = this.setError.bind(this);
        this.go = this.go.bind(this);
    }
    go(idx){
        this.setState({idx:idx});
    }
    handleChange(event) {
        let { name, value } = event.target;
        if (name==="passwordConfirm") {
            this.setState({
                passwordConfirm: value
            });
            if (value===this.state.password) this.setError("passwordConfirm","");
            return;
        }
        if (name==="password") {
            if (value.length>=5) this.setError("password","");
            if (value===this.state.passwordConfirm) this.setError("passwordConfirm","");
        }
        this.setState({[name]: value});
    }
    handleSubmit(e) {
        e.preventDefault();
        this.setState({ submitted: true });
        const { passwordConfirm, password } = this.state;
        if (passwordConfirm && password) {
            axios.post(Conf.apiBaseUriLegacy+"/user/reset_password",Qs.stringify({
                selector:this.props.selector,
                token:this.props.token,
                password:this.state.password,
            }),{withCredentials:true})
            .then((res) => {
                if (res.data.status==='success') {
                    this.setState({error:'',email:res.data.email});
                    this.go(1);
                    this.props.methods.getProfile();
                } else {
                    this.setState({error:res.data.error});
                }
            });
        }
    }
    setError(name,value) {
        const errors=this.state.errors;
        this.setState({
            errors: {
                ...errors,
                [name]: value
            }
        });
    }
    render() {
        let errors=this.state.errors;
        const { t } = this.props;
        return <Dialog open={this.props.open} onClose={this.props.onClose} scroll="body" className="my-dialog">
            <DialogTitle>
                {t('nouveau-mot-de-passe')}
            </DialogTitle>
            <Pager idx={this.state.idx} pages={[
                <form onSubmit={this.handleSubmit}>
                <DialogContent>
                    <p>{t('merci-de-saisir-votre-nouveau-mot-de-passe')}</p>
                    <TextField
                    label={t('mot-de-passe')}
                    name="password"
                    type="password"
                    variant="filled"
                    margin="dense"
                    fullWidth
                    value={this.state.password}
                    onBlur={this.checkPassword}
                    onChange={this.handleChange}
                    error={ Boolean(errors.password) }
                    helperText={ (errors.password) ? errors.password : t('5-caracteres-minimum') }
                    />
                    <TextField
                    label={t('confirmation-du-mot-de-passe')}
                    name="passwordConfirm"
                    variant="filled"
                    type="password"
                    margin="dense"
                    fullWidth
                    value={this.state.passwordConfirm}
                    onChange={this.handleChange}
                    onBlur={this.checkPasswords}
                    error={ Boolean(errors.passwordConfirm) }
                    helperText={ (errors.passwordConfirm) ? errors.passwordConfirm : "" }
                    />
                    {this.state.error &&
                      <FormHelperText error >{ this.state.error }</FormHelperText>
                    }
                </DialogContent>
                <DialogActions>
                    <Button
                    color="primary"
                    variant="outlined"
                    className="btn btn-primary"
                    onClick={this.props.onClose}
                    >
                        {t('fermer')}
                    </Button> &nbsp;
                    <Button
                    type="submit"
                    color="primary"
                    variant="contained"
                    className="btn btn-primary"
                    >
                        {t('suivant')}
                    </Button>
                </DialogActions>
                </form>,
                <React.Fragment>
                <DialogContent>
                    <p>{t('votre-mot-de-passe-a-bien-ete-modifie')}</p>
                    <p>
                        <Trans i18nKey="vous-etes-connecte-avec-le-compte" values={{email: this.state.email}}>
                            Vous êtes connecté avec le compte <strong>{{email: this.state.email}}</strong>.
                        </Trans>
                    </p>
                </DialogContent>
                <DialogActions>
                    <Button
                    color="primary"
                    variant="contained"
                    className="btn btn-primary"
                    onClick={this.props.onClose}
                    >
                        {t('fermer')}
                    </Button>
                </DialogActions>
                </React.Fragment>
            ]}/>
        </Dialog>;
    }
}
export default withTranslation()(PasswordReset);
